// extracted by mini-css-extract-plugin
module.exports =  {"fields":"fields--JCwJF"};